import React from 'react'
import styled from 'styled-components'
import { ErrorIcon as ErrorIconBase } from '@chilecompra/react-kit/components'

export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 67px 100px 70px;
  ${props => props.theme.breakpoints.down('md')} {
    ${() => {
      return 'padding: 37px 50px 50px'
    }}
  }

  ${props => props.theme.breakpoints.down('sm')} {
    ${() => {
      return 'padding: 10px 0'
    }}
  }
`

export const DialogWrapperConfirmed = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 22px 18px;
  ${props => props.theme.breakpoints.down('md')} {
    ${() => {
      return 'padding: 25px 22px 18px'
    }}
  }

  ${props => props.theme.breakpoints.down('sm')} {
    ${() => {
      return 'padding: 10px 0'
    }}
  }
`

export const Row = styled('div')`
  margin: ${props => props.margin};
  text-align: center;
  width: ${props => props.width || '100%'};
  ${props => props.theme.breakpoints.up('sm')} {
    ${props => {
      if (props.width)
        return `
        width: ${props.width};
      `
    }}
  }
`
export const RowRadio = styled('div')`
  text-align: left;
  width: 100%;
  margin: 20px 10px 50px;
`

export const Strong = styled('span')`
  font-weight: bold;
  font-size: 14px;
`

export const BoxInput = styled('div')`
  width: 90%;
  margin: 0 25px 0 37px;
`

export const ContainerError = styled('div')`
  display: flex;
  justify-content: start;
`
export const ErrorIcon = styled(({ ...props }) => <ErrorIconBase {...props} />)`
  margin: 8px 0 0 8px;
  color: ${props => props.theme.palette.red[50]};
`
